module.exports = __webpack_public_path__ + "img/chevron-next.4f7d2e60.svg";